import resourceObj from './resource';
const errImg = require('../img/error.png');
export default {
    getOs() {
        if (!window.PPDWebUI) {
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
            var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            if (isAndroid) {
                return 2;
            } else {
                return 1;
            }
        }
        if (
            window.PPDWebUI &&
            window.PPDWebUI.os &&
            window.PPDWebUI.os.inApp &&
            window.PPDWebUI.os.android
        ) {
            return 2;
        } else {
            return 1;
        }
    },
    uuid() {
        var s = [];
        var hexDigits = '0123456789abcdef';
        for (var i = 0; i < 36; i++) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
        s[8] = s[13] = s[18] = s[23] = '-';

        var uuid = s.join('');
        return uuid;
    },

    getCookie(name) {
        //读取cookies
        var arr,
            reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
        if ((arr = document.cookie.match(reg))) return arr[2];
        else return null;
    },
    getMiappUseragentKey() {
        var appId =  '';
        if (window.__wxjs_environment === 'miniprogram' && this.getCookie('miniappPlatform')) { 
            if (!(window.location.protocol.indexOf('http:') > -1)) { 
                appId = '41001'
            }
        }
        var isTTWebView = navigator.userAgent.toLowerCase().includes("toutiaomicroapp");
        if (isTTWebView) {
            if (!(window.location.protocol.indexOf('http:') > -1)) { 
                appId = '41002'
            }
        }

        return {
            appId: appId
        };
     },
    // 从useragent里面获取相应的参数
    getUseragentKey() {
        var userAgent = navigator.userAgent;
        // var userAgent = 'Mozilla/5.0 (Linux; Android 6.0.1; SM-G9280 Build/MMB29K; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/55.0.2883.91 Mobile Safari/537.36 PPDWebUI/1.1.7 PPDLoanApp/7.4.0.19012402 (AppID/10080004; huawei; PPDStatusBar 40) DUID/cee8a5af63ba7bbfcfaa0ebff9b68b7042282767';
        var list = [
            'PPDLoanApp',
            'PPDHuanApp',
            'PPDCSDApp',
            'PPDJQHApp',
            'PPDBBCarApp',
            'PPDKoouApp',
            'PPDKoobApp',
            'PPDLenderApp'
        ];
        var len = list.length;
        // 找到对应的渠道pid
        for (var i = 0; i < len; i++) {
            if (userAgent.indexOf(list[i]) > -1) {
                var pid = list[i];
            }
        }
        var appIdReg = /.*AppID\/(\d+).*/;
        var duidReg = /.*DUID\/([a-zA-Z0-9]+).*/;
        var versionReg = new RegExp('.*' + pid + '/([.0-9]+).*');
        var buildTypeReg = /.*BuildType\/([a-zA-Z]+)*/;
        var appId = (appIdReg.exec(userAgent) && appIdReg.exec(userAgent)[1]) || '';
        // var duid = duidReg.exec(userAgent) && duidReg.exec(userAgent)[1] || '';
        var version = (versionReg.exec(userAgent) && versionReg.exec(userAgent)[1]) || '';
        var buildType = (buildTypeReg.exec(userAgent) && buildTypeReg.exec(userAgent)[1]) || '';
        var appos = 1;
        var platform = '';
        var _userAgent = userAgent.toLowerCase();
        // cp duid 从客户端获取
        // console.log('cp:', this.getCookie('cp'), window.PPDWebUI.appInfos && window.PPDWebUI.appInfos.cp)
        let cp =
            this.getCookie('cp') ||
            (window.PPDWebUI && window.PPDWebUI.appInfos && window.PPDWebUI.appInfos.cp) ||
            '';
        // console.log('cp 1:', JSON.stringify(cp));
        let duid =
            (window.PPDWebUI && window.PPDWebUI.appInfos && window.PPDWebUI.appInfos.DUID) ||
            (duidReg.exec(userAgent) && duidReg.exec(userAgent)[1]) || localStorage.getItem('xinyeBrowserId') || 
            '';
        if (_userAgent.indexOf('iphone') > -1) {
            platform = 'ios';
            appos = 1;
        } else {
            platform = 'Android';
            appos = 2;
        }
        return {
            pid: pid,
            appId: appId,
            buildType: buildType === 'Debug' ? '1' : '2',
            version: version || '6.8.0',
            platform: platform,
            appos: appos,
            cp,
            duid
        };
    },

    // 转化时间格式
    setTimestamp(t) {
        if (t) {
            let year = t.getFullYear();
            let month = this.addZeroToNumber(t.getMonth() + 1, 2);
            let date = this.addZeroToNumber(t.getDate(), 2);
            let hour = this.addZeroToNumber(t.getHours(), 2);
            let min = this.addZeroToNumber(t.getMinutes(), 2);
            let seconds = this.addZeroToNumber(t.getSeconds(), 2);
            let milliSeconds = this.addZeroToNumber(t.getMilliseconds(), 3);
            return (
                [year, month, date].join('-') +
                ' ' +
                [hour, min, seconds].join(':') +
                '.' +
                milliSeconds
            );
        } else {
            return false;
        }
    },

    // 对数字进行补位
    addZeroToNumber(num, count) {
        var arr = [];
        var len = String(num).length;
        if (len < count) {
            var space = count - len;
            for (var i = 0; i < space; i++) {
                arr.push('0');
            }
            return arr.join('') + num;
        }
        return num;
    },

    // 获取页面元素到顶部的距离
    getOffsetTop(ele) {
        let offsetTop = ele.offsetTop;
        if (ele.offsetParent !== null) {
            offsetTop += this.getOffsetTop(ele.offsetParent);
        }
        return offsetTop;
    },
    // 获取对应的目标数组
    getSourceArr(arr, type, val) {
        var _arr = [];
        for (var i = 0; i < arr.length; i++) {
            if (arr[i][type] === val) {
                _arr.push(arr[i]);
            }
        }
        return _arr;
    },

    findMissedResource(link) {
        let module = '';
        let path = window.location.pathname;
        if (path) {
            let arr = path.split('/');
            if (arr[arr.length - 1] === 'index.html') {
                module = arr[arr.length - 2];
            } else {
                module = arr[arr.length - 1];
            }
        }
        // 获取当前页面的key,且找到必须引用的js
        let key = window.location.hostname + '-' + module;
        let resultArr = resourceObj[key] || [];
        resultArr.forEach(item => {
            if (link.includes(item)) {
                // toast找不到的js
                setTimeout(() => {
                    this.toastError(`网络出错，请退出重试，${item}(404)`);
                }, 0);
            }
        });
    },

    toastError(message) {
        let judgeToast = document.querySelector('.ppd-toast-wrap');
        if (judgeToast) {
            return;
        }
        let style = document.createElement('style');
        let cssText =
            '.ppd-toast-wrap{animation:showToast 0.5s;animation-fill-mode: forwards;position:fixed;z-index:999;top:50%;left:50%;transform:translate(-50%,-50%);max-width:80%;line-height:22px;padding:10px;border-radius:3px;background:rgba(0,0,0,0.9);color:#fff;font-size:14px;}@keyframes showToast{0% {opacity:0;} 100% {opacity:0.9;}}';
        style.innerHTML = cssText;
        document.head.appendChild(style);
        let el = document.createElement('div');
        el.className = 'ppd-toast-wrap';
        el.innerText = message;
        document.body.appendChild(el);
        setTimeout(() => {
            el.parentNode.removeChild(el);
        }, 2000);
    },

    // 设置h5网关跟多租户网关的请求头
    setHeader(type) {
        let header = {};
        if (type === 'multi') {
            header = {
                'X-GW-TENANTID': 'f36caab1',
                'X-GW-APPID': '1000002863',
                'X-GW-PLATFORM': 'h5',
                'X-GW-TIMESTAMP': parseInt(new Date().getTime() / 1000),
                'X-GW-TOKEN': this.getCookie('token')
            };
        } else {
            header = {
                'X-PPD-APPOS': this.getOs(),
                'X-PPD-APPID': this.getUseragentKey().appId,
                'X-PPD-APPVERSION': this.getUseragentKey().version,
                'X-PPD-TIMESTAMP': parseInt(new Date().getTime() / 1000),
                'X-PPD-KEY': 'tc-002',
                'X-PPD-KEYVERSION': 1
            };
        }
        return header;
    },

    // 获取参数
    getParamsFormScript(id, attr) {
        const script = document.getElementById(id);
        let obj = {};

        if (script) {
            const params = script.getAttribute(attr);
            if (params) {
                const arr = params.split('&');
                arr.forEach(item => {
                    const _arr = item.split('=');
                    obj[_arr[0]] = _arr[1];
                });
            }
        }

        return obj;
    },

    showErrorPage() {
        let style = document.createElement('style');
        let cssText =
            '.ppd-error-wrap{width: 100%; height: 100%; position: absolute; top: 0; bottom: 0; left: 0; right: 0; background: #fff; z-index: 100000;}.ppd-error-img{width: 32.266666vw; height: 29.066666vw; margin: auto; margin-top: 41.333333vw; display: block}' +
            '.ppd-error-tip{font-family: fzlt; color: #384369; font-size: 4.266666vw; line-height: 4.8vw; margin-top: 2.666666vw; text-align: center;}.ppd-error-retry{font-family: fzlt; color: #7585BE; font-size: 3.733333vw; line-height: 4.266666vw; margin-top: 3.2vw; text-align: center; }';
        style.innerHTML = cssText;
        document.head.appendChild(style);
        let wrap = document.createElement('div');
        wrap.className = 'ppd-error-wrap';
        let img = document.createElement('img');
        img.src = errImg;
        img.className = 'ppd-error-img';
        wrap.appendChild(img);
        let p1 = document.createElement('p');
        p1.innerText = '加载失败,请检查网络设置';
        p1.className = 'ppd-error-tip';
        wrap.appendChild(p1);
        let p2 = document.createElement('p');
        p2.innerText = '轻触屏幕重新加载';
        p2.className = 'ppd-error-retry';
        p2.addEventListener('click', () => {
            location.reload();
        });
        wrap.appendChild(p2);
        document.body.appendChild(wrap);
    },

    isEleInArray(target, arr) {
        if (!Array.isArray(arr)) {
            return;
        }
        if (!target || target === document.documentElement) {
            return false;
        } else if (arr.indexOf(target) !== -1) {
            return true;
        } else {
            return this.isEleInArray(target.parentElement, arr);
        }
    },
    // 判断目标元素是否在首屏内
    isInFirstScreen(target) {
        if (!target || !target.getBoundingClientRect) return false;
        let rect = target.getBoundingClientRect(),
            screenHeight = window.innerHeight,
            screenWidth = window.innerWidth;
        return (
            rect.left >= 0 && rect.left < screenWidth && rect.top >= 0 && rect.top < screenHeight
        );
    },
    // 过滤掉无效值的属性
    filterInvalidProps(obj, props, func) {
        const deleteRule = p => {
            if (obj[p] <= 0 || obj[p] > 10000 || !obj[p]) {
                delete obj[p];
            }
        };
        if (func && props) {
            props.forEach(p => {
                if (!func(obj[p])) {
                    delete obj[p];
                }
            });
        } else if (props) {
            props.forEach(p => {
                deleteRule(p);
            });
        } else {
            for (let key in obj) {
                deleteRule(key);
            }
        }
    }
};
